import numeral from 'numeral'

numeral.register('locale', 'it-ch', {
  delimiters: {
    thousands: "'",
    decimal: '.',
  },
  abbreviations: {
    thousand: 'mila',
    million: 'mil',
    billion: 'b',
    trillion: 't',
  },
  ordinal: function(number) {
    return 'Âº'
  },
  currency: {
    symbol: 'CHF',
  },
})
